module.exports = __webpack_public_path__ + "static/media/perspective-taking@2x.154aa4f3.png";